import { useEffect } from "react";

export function useViewport() {
    useEffect(() => {
        const setViewportVars = () => {
            const vv = window.visualViewport;

            // fallback для браузерів без visualViewport
            const height = vv?.height ?? window.innerHeight;
            const top = vv?.offsetTop ?? 0;

            document.documentElement.style.setProperty("--vvh", `${height}px`);
            document.documentElement.style.setProperty("--vvt", `${top}px`);
        };

        setViewportVars();

        const vv = window.visualViewport;
        if (!vv) {
            window.addEventListener("resize", setViewportVars);
            return () => window.removeEventListener("resize", setViewportVars);
        }

        vv.addEventListener("resize", setViewportVars);
        vv.addEventListener("scroll", setViewportVars); // важливо на iOS
        return () => {
            vv.removeEventListener("resize", setViewportVars);
            vv.removeEventListener("scroll", setViewportVars);
        };
    }, []);
}
